import { useCurrentClientAtom, CurrencyCode } from 'atoms';
import { CURRENCY_MAP } from '../constants';

export const useCurrentClientCurrency = (): {
  currencyCode: CurrencyCode;
  currencySymbol: string;
  replaceSymbolIfCurrencyNotUSD: (data: string) => string;
} => {
  const [{ current_client_currency_code }] = useCurrentClientAtom();

  // Validate if currency code exists
  if (!current_client_currency_code) {
    // Return default currency if no current_client_currency_code exists
    return {
      currencyCode: 'USD',
      currencySymbol: '$',
      replaceSymbolIfCurrencyNotUSD: (data: string) => data,
    };
  }

  const getCurrencySymbol = (currencyCode: CurrencyCode): string => {
    return CURRENCY_MAP[currencyCode];
  };

  // Fetch currency symbol
  const currencySymbol = getCurrencySymbol(current_client_currency_code);

  // Function to replace dollar sign with applicable currency symbol, incase client currency is other than USD
  const replaceSymbolIfCurrencyNotUSD = (data: string): string => {
    if (current_client_currency_code === 'USD' || !data.startsWith('$')) {
      return data;
    }

    // Add space after, if the symbol is long or it is a currency code, space helps for readability, set fallback to $
    const symbol = currencySymbol
      ? currencySymbol.length > 1
        ? currencySymbol + ' '
        : currencySymbol
      : '$';

    // Remove the $ and insert the currency symbol at the beginning of the number
    const numberPart = data.slice(1);
    return symbol + numberPart;
  };

  return {
    currencyCode: current_client_currency_code,
    currencySymbol,
    replaceSymbolIfCurrencyNotUSD,
  };
};
